var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Entity, Type } from '@decahedron/entity';
import env from 'config/env';
import { Candidate } from 'packages/v3/jobs/Candidate';
import { actions } from './actions';
import { mutations } from './mutations';
var ImportResponse = /** @class */ (function (_super) {
    __extends(ImportResponse, _super);
    function ImportResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Type(Candidate),
        __metadata("design:type", Array)
    ], ImportResponse.prototype, "new", void 0);
    __decorate([
        Type(Candidate),
        __metadata("design:type", Array)
    ], ImportResponse.prototype, "existing", void 0);
    return ImportResponse;
}(Entity));
export { ImportResponse };
var ImportCandidatesRepository = /** @class */ (function (_super) {
    __extends(ImportCandidatesRepository, _super);
    function ImportCandidatesRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'jobs/:jobId/candidates';
        _this.baseUrl = env.JOBILLA_API_ROOT + "v3/";
        _this.entity = ImportResponse;
        return _this;
    }
    ImportCandidatesRepository.prototype.importCandidates = function (jobId, candidates) {
        return this.post(this.url, { candidates: candidates }, { jobId: jobId });
    };
    return ImportCandidatesRepository;
}(AbstractRepository));
export { ImportCandidatesRepository };
var state = {
    newCandidates: null,
    duplicateCandidates: null,
    ignoredCandidates: null,
    importing: false,
    imported: false,
    errors: null,
};
export var importCandidates = {
    state: state,
    namespaced: true,
    actions: actions,
    mutations: mutations,
};
